import React from 'react';
import { HtmlManager } from './manager.mjs';

const HtmlContext = /*#__PURE__*/React.createContext(new HtmlManager());

export { HtmlContext };
